import React from 'react';

import Div from '../../Element/Div/Div';
import Flex from '../../Flex/Flex';
import Gutter from '../../Gutter/Gutter';

function LinkListHeading({ children }) {
  return (
    <Flex occupyVerticalSpace={false}>
      <Gutter size="xlg" responsiveHidden={{ widerThan: 'md' }} />

      <Gutter responsiveHidden={{ thinnerThan: 'lg' }} />

      <Div flexItem>{children}</Div>
    </Flex>
  );
}

export default LinkListHeading;
